import React from 'react';
import Head from 'next/head';

type PreloadResourcesProps = {
    list: string[];
}

const PreloadResources: React.FC<PreloadResourcesProps> = props => {
    const list = Array.from(new Set(props.list.filter(item => item.length > 0)));

    return list.length > 0 ? (
        <Head>
            {list.map(item => <link key={item} rel="preload" as="image" href={item}/>)}
        </Head>
    ) : null;
}

export default PreloadResources;